/*============================================================================
  QuickSizeAdd
  ------------------------------------------------------------------------
  Collection/grid par size-button click hote hi us variant ko /cart/add.js
  se add karta hai, aur SAME response ke 'sections' data se drawer content
  update karta hai (koi alag GET request nahi).

  IMPORTANT - iska poora fix history:
  1st attempt: Dawn ke renderContents() (#CartDrawer selector) - is theme
    ke actual DOM structure (cart-drawer-items / .cart-drawer__footer) se
    match nahi karta tha -> blank drawer.
  2nd attempt: theme ke CartDrawerItems.onCartUpdate() jaisa - ek ALAG GET
    request '/cart?section_id=cart-drawer' bhejna. Correct selectors the,
    lekin fresh/empty cart par pehli baar item add karte waqt Shopify naya
    cart-session cookie response headers mein set karta hai, aur humari
    turant wali GET request us naye cookie se pehle hi fire ho jaati thi -
    isliye use OLD/empty cart state milta tha (item add ho chuka hota tha,
    bas dikhta nahi tha - page reload par sahi dikhta tha).
  FINAL fix (ye file): koi alag GET request hi nahi - /cart/add.js ke POST
    body mein hi 'sections' maango. Us SAME response mein already-updated
    cart ka HTML aata hai (koi cookie-timing race nahi ho sakti, kyunki
    ye ek hi request-response cycle hai). Us HTML se sirf 'cart-drawer-items'
    aur '.cart-drawer__footer' nikaal ke DOM mein replace karte hain -
    exact wahi selectors jo theme ka apna onCartUpdate() use karta hai.

  Load order: theme.js ke BAAD load hona chahiye.
==============================================================================*/
(function () {
  'use strict';

  // Duplicate-load guard - agar script kabhi 2 jagah se load ho jaye
  if (window.__quickSizeAddInitialized) {
    return;
  }
  window.__quickSizeAddInitialized = true;

  // Stale-response guard - sirf sabse latest click ka result hi DOM update kare
  var latestRequestToken = 0;

  function getUnavailableMessage(data) {
    if (!data) {
      return (theme.strings && theme.strings.unavailable) || 'This item is unavailable.';
    }
    if (typeof data.description === 'string' && data.description) {
      return data.description;
    }
    if (typeof data.message === 'string' && data.message) {
      return data.message;
    }
    if (data.description && typeof data.description === 'object') {
      return data.message || (theme.strings && theme.strings.unavailable) || 'This item is unavailable.';
    }
    return (theme.strings && theme.strings.unavailable) || 'This item is unavailable.';
  }

  function showQuickSizeError(btn, message) {
    var container = btn.closest('.quick-size-add');
    if (!container) {
      window.alert(message);
      return;
    }
    var existing = container.querySelector('.quick-size-add__error');
    if (existing) existing.remove();

    var errorEl = document.createElement('div');
    errorEl.className = 'quick-size-add__error errors text-center';
    errorEl.setAttribute('role', 'alert');
    errorEl.textContent = message;
    container.appendChild(errorEl);

    window.clearTimeout(container._quickSizeErrorTimer);
    container._quickSizeErrorTimer = window.setTimeout(function () {
      if (errorEl.parentNode) errorEl.remove();
    }, 3500);
  }

  function resolveVariantId(btn) {
    if (btn.dataset.variantId) return btn.dataset.variantId;
    var form = btn.closest('form');
    if (!form) return null;
    var idInput = form.querySelector('[name="id"]');
    return idInput ? idInput.value : null;
  }

  function getCartAddUrl() {
    if (window.routes && routes.cart_add_url) {
      return routes.cart_add_url;
    }
    if (window.theme && theme.routes && theme.routes.cartAdd) {
      return theme.routes.cartAdd;
    }
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart/add.js';
    }
    return '/cart/add.js';
  }

  // Add.js response ke 'sections' object se ek section ka HTML nikaal ke
  // usme se specific selector match karke DOM mein replace karo.
  function replaceFromSectionHtml(sectionHtml, selector) {
    if (!sectionHtml) return false;

    var parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var sourceElement = parsedDoc.querySelector(selector);
    var targetElement = document.querySelector(selector);

    if (sourceElement && targetElement) {
      targetElement.replaceWith(sourceElement);
      return true;
    }
    return false;
  }

  function updateCartDrawerFromSections(sections) {
    if (!sections) return;

    var cartDrawerHtml = sections['cart-drawer'];
    if (cartDrawerHtml) {
      replaceFromSectionHtml(cartDrawerHtml, 'cart-drawer-items');
      replaceFromSectionHtml(cartDrawerHtml, '.cart-drawer__footer');
    }

    var cartIconHtml = sections['cart-icon-bubble'];
    if (cartIconHtml) {
      var parsedDoc = new DOMParser().parseFromString(cartIconHtml, 'text/html');
      var sourceIcon = parsedDoc.querySelector('#cart-icon-bubble');
      var targetIcon = document.querySelector('#cart-icon-bubble');
      if (sourceIcon && targetIcon) {
        targetIcon.replaceWith(sourceIcon);
      }
    }
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.quick-size-add__btn');
    if (!btn) return;

    evt.preventDefault();
    evt.stopPropagation();

    if (
      btn.disabled ||
      btn.getAttribute('aria-disabled') === 'true' ||
      btn.classList.contains('quick-size-add__btn--sold-out') ||
      btn.classList.contains('is-adding')
    ) {
      showQuickSizeError(
        btn,
        (theme.strings && (theme.strings.soldOut || theme.strings.unavailable)) ||
          'This item is unavailable.'
      );
      return;
    }

    var variantId = resolveVariantId(btn);
    if (!variantId) {
      showQuickSizeError(
        btn,
        (theme.strings && theme.strings.unavailable) || 'This item is unavailable.'
      );
      return;
    }

    btn.classList.add('is-adding');

    latestRequestToken += 1;
    var thisRequestToken = latestRequestToken;

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify({
        id: Number(variantId) || variantId,
        quantity: 1,
        // Yahi sections maangna race-condition-proof update ki key hai -
        // ye SAME response mein already-updated cart ka HTML de dega.
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, status: response.status, data: data };
        }).catch(function () {
          return {
            ok: false,
            status: response.status,
            data: {
              description:
                (theme.strings && theme.strings.unavailable) ||
                'This item is unavailable.'
            }
          };
        });
      })
      .then(function (result) {
        // Agar iske beech koi naya click ho chuka hai, to ye result discard karo
        if (thisRequestToken !== latestRequestToken) {
          return;
        }

        var data = result.data || {};
        var unavailable =
          !result.ok ||
          result.status === 422 ||
          data.status === 422 ||
          data.status === 'bad_request';

        if (unavailable) {
          showQuickSizeError(btn, getUnavailableMessage(data));
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:error', {
              detail: { errorMessage: getUnavailableMessage(data) },
              bubbles: true
            })
          );
          return;
        }

        // Item add ho gaya - isi response ke 'sections' se drawer update karo,
        // koi alag request nahi (isse cookie-timing race khatam ho jaati hai).
        updateCartDrawerFromSections(data.sections);

        // CRITICAL: agar cart pehle genuinely khaali thi, to '<cart-drawer>'
        // wrapper aur '.drawer__inner' par 'is-empty' class lagi hoti hai,
        // jo CSS se empty-state message force-show aur items force-hide
        // karti hai - chahe HTML content sahi update ho chuka ho. Item add
        // ho chuka hai (yahan tak pahunche hain matlab success hai), isliye
        // ye class hata do taaki updated items dikhne lagein. Theme ka apna
        // CartItems.updateQuantity() bhi exactly yehi karta hai.
        var cartDrawerWrapperForEmpty = document.querySelector('cart-drawer');
        if (cartDrawerWrapperForEmpty) {
          cartDrawerWrapperForEmpty.classList.remove('is-empty');
        }
        var drawerInnerForEmpty = document.querySelector('.drawer__inner');
        if (drawerInnerForEmpty) {
          drawerInnerForEmpty.classList.remove('is-empty');
        }
        var cartDrawerItemsForEmpty = document.querySelector('cart-drawer-items');
        if (cartDrawerItemsForEmpty) {
          cartDrawerItemsForEmpty.classList.remove('is-empty');
        }

        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
          cartDrawerEl.open();
        }

        // Backward-compat event
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: { product: data, addToCartBtn: btn },
            bubbles: true
          })
        );
      })
      .catch(function (error) {
        console.error('QuickSizeAdd error:', error);
        showQuickSizeError(
          btn,
          (theme.strings && theme.strings.unavailable) || 'This item is unavailable.'
        );
      })
      .finally(function () {
        btn.classList.remove('is-adding');
      });
  }, true);
})();